import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import TableField from '../../form/fields/TableField';
import { AvForm } from 'availity-reactstrap-validation';
import { history } from '../../../../history';
import { getStoreTableByNamePublic } from '../../../../utility/sb-api/sb-api.service';
import { notification } from '../../../../utility/notification/notification.service';
import { ROUTE_TABLE } from '../../../../utility/constants';
import LoadingSpinner from './LoadingSpinner';

const DynamicTable = ({ isOpen, closeModal, store }) => {
  const [tableName, setTableName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleTableNameChange = (e) => {
    setTableName(e.target.value);
  };

  const handleButtonClick = () => {
    const name = tableName.trim();
    if (!name) return;

    setLoading(true);
    // Resolved server-side: the public list deliberately omits `slug`, so the
    // client cannot turn a name into a slug on its own.
    getStoreTableByNamePublic(store?.id, name)
      .then((table) => {
        // Only on success: the hand-off unmounts this component.
        closeModal(false);
        history.replace(`${ROUTE_TABLE}/${table.slug}`);
      })
      .catch((error) => {
        setLoading(false);
        notification(
          'error',
          error.response?.status === 409
            ? 'dynamicTableAmbiguousErrorMsg'
            : 'dynamicTableErrorMsg',
        );
      });
  };

  return (
    <Modal isOpen={isOpen} className="modal-dialog modal-dialog-centered">
      <ModalHeader>
        <FormattedMessage id="dynamicTableTitle" />
      </ModalHeader>
      <ModalBody style={{ paddingBottom: 'inherit' }}>
        <div>
          <FormattedMessage id="dynamicTableText" />
          <AvForm className="mt-2">
            <TableField
              data-testid="nameInputField"
              propertyName="name"
              messageId="name"
              required
              value={tableName}
              onChange={handleTableNameChange}
            />
          </AvForm>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="w-100" color="primary" onClick={handleButtonClick}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <FormattedMessage id="dynamicTableButtonText" />
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  store: state.store.store,
  table: state.store.table,
});

export default connect(mapStateToProps)(DynamicTable);
